import { Container, Typography, Paper } from "@mui/material";

import RequiredAsterisk from '../../utils/RequiredAsterisk'

const QuoteFormHeader = () => {
  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
        <Paper elevation={0} sx={{ p: { md: 2 }, mb: { xs: 2, md: 2 } }}>
            <Typography variant="h6"
                sx={{ 
                    fontWeight: "bold", 
                    mb: 0.5, 
                    color: "text.primary" 
                }}>
                DATOS DE COTIZACIÓN
            </Typography>
            <Typography variant="body1" 
                sx={{ 
                    color: "text.secondary", 
                    fontSize: "1rem", 
                    mb: 2,
                    maxWidth: { 
                        xs: '80%',
                        sm: '100%',
                        md: '100%'
                    }
                }}>
                Todos los campos marcados con <RequiredAsterisk /> son obligatorios
            </Typography>
        </Paper>
    </Container>
  );
};

export default QuoteFormHeader